import JsBarcode from 'jsbarcode'

const _makeImage = (dataUrl) => {
    const image = new Image()
    image.src = dataUrl

    return new Promise(resolve => {
        image.onload = () => {
            resolve(image)
        }
    })
}

const textToBase64Barcode = (text) => {
    var canvas = document.createElement("canvas")
    JsBarcode(canvas, text, { displayValue: true })
    return canvas.toDataURL("image/png")
}


const LABEL_WIDTH = 1440
const LABEL_HEIGHT = 480
export default async (barcodeNumber, partnerTrackingNumber, shipping_level) => {
    //Information label
    const barcode_number = `#${barcodeNumber}`

    //Barcode image
    const data = textToBase64Barcode(partnerTrackingNumber)
    const barcodeImage = await _makeImage(data)

    //Created canvas
    const canvas = document.createElement('canvas')
    canvas.width = LABEL_WIDTH
    canvas.height = LABEL_HEIGHT
    const ctx = canvas.getContext('2d')

    //Init canvas page
    ctx.beginPath()
    ctx.fillStyle = 'white'
    ctx.fill()

    //Draw rect
    ctx.lineWidth = 4
    ctx.rect(10, 45, LABEL_WIDTH - 50, LABEL_HEIGHT - 50)
    ctx.stroke()

    //Draw label number
    ctx.fillStyle = 'black'
    ctx.font = 'bold 70px Arial'
    // var a = canvas.width / 2;
    // ctx.textAlign = "center";
    // ctx.textBaseline = "middle";
    ctx.fillText(barcode_number, 50, 150)

    //Draw barcode
    // var margin = (canvas.width - 400) / 2
    ctx.drawImage(barcodeImage, 550, 55, 830, 415)

    //Draw tracking number
    // ctx.fillStyle = 'black'
    // ctx.font = 'bold 40px Arial'
    // // var b = canvas.width / 2;
    // // ctx.textAlign = "center";
    // // ctx.textBaseline = "middle";
    // var margin1 = (canvas.width - 450) / 2 + 250
    // ctx.fillText(partnerTrackingNumber, margin1, 450)

    if (shipping_level === 60) {
        ctx.fillStyle = 'black'
        ctx.font = 'bold 100px Arial'
        ctx.fillText('P', 50, 300)
    }
    if (shipping_level !== 'ib_blue' && shipping_level !== 60) {
        ctx.fillStyle = 'black'
        ctx.font = 'bold 100px Arial'
        ctx.fillText('F', 50, 300)
    }

    return canvas.toDataURL()
}
